export default "__VITE_ASSET__wop4u576__"